// React
import Owner from 'models/Owner';
import React from 'react';
// External libraries
import { Button, Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { getBookingWithoutAuth } from 'services/booking';
import { guestLogin } from 'services/users';
import getFormFieldVal from 'utils/getFormFieldVal';
import config from 'config/config';
// Styles
import './styles.scss';

/**
 * @todo the login must be done against the phone number but credentials are required to request the data,
 * this has to be changed to the backend or create a user only for the purpose of this process
 */
class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bookingId: props.match.params.bookingId,
            owner: Owner(),
            phoneNumber: '',
            loginFailedMessage: ''
        };
        this.getBookingDetails();
    }

    handlePhoneInputChange(evt) {
        const { phoneNumber } = getFormFieldVal(evt);
        const numberRegEx = /^[0-9]*$/;
        if (numberRegEx.test(phoneNumber)) {
            this.setState({
                phoneNumber,
                invalidCredentials: false
            });
        }
    }

    async onSubmit() {
        if (!this.state.owner.phoneNumber) {
            return;
        }
        // Removes the international code to compare with the phone from the form field
        const numberToCompare = this.state.owner.phoneNumber.replace('+61', '');
        if (numberToCompare === this.state.phoneNumber) {
            // Adds the number to the SESSION STORAGE
            sessionStorage.setItem(config.CLIENT_TOKEN, JSON.stringify(this.state.owner));

            guestLogin(config.GUEST_USERNAME, config.GUEST_PASSWORD)
                .then(() => {
                    // Login success for booking
                    this.props.history.push(`/engraving/check-existing?`
                        + `staff=0&bookingId=${this.props.bookingId}&quotedProductId=${this.props.quotedProductId}`);
                }).catch((err) => {
                    console.error('err :>> ', err);
                    this.setState({ loginFailedMessage: 'Sorry, login failed' });
                });
        } else {
            this.setState({ invalidCredentials: true });
        }
    }

    getBookingDetails() {
        if (!this.state.bookingId) {
            return;
        }
        getBookingWithoutAuth(this.state.bookingId)
            .then((response) => {
                this.setState({ owner: Owner(response.data.cstm.client_details_c) });
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    render() {
        return (
            <>
                <Form className="inline-block-below-lg">
                    <Form.Group
                        controlId="mobile-number"
                        className="control-group control-number inline-block-below-lg"
                    >
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            name="phoneNumber"
                            className={`${this.state.invalidCredentials ? 'is-invalid' : ''} `
                                + `inline-block-below-lg`}
                            onChange={(evt) => this.handlePhoneInputChange(evt)}
                            type="text"
                            placeholder="Phone number"
                            minLength="9"
                            maxLength="9"
                            value={this.state.phoneNumber}
                        />
                    </Form.Group>

                    <Button className="btn-primary inline-block-below-lg" onClick={() => this.onSubmit()}>
                        Submit
                    </Button>

                    {
                        this.state.invalidCredentials
                            ? <p className="error-msg">The phone number is invalid for this engraving.</p>
                            : null
                    }

                    {
                        this.state.loginFailedMessage !== ''
                            ? <p className="error-msg">{this.state.loginFailedMessage}</p>
                            : null
                    }
                </Form>
            </>
        );
    }
}

export default withRouter(LoginForm);
